import { catchError, EMPTY, throwError } from 'rxjs';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastSeverity } from '../../shared/enums/toast-severity.enum';
import { DialogService } from 'primeng/dynamicdialog';
import { APP_PATHS } from '../config/app-paths';
import { SpinnerService } from '../services/spinner.service';
import { AuthService } from '../services/auth.service';

export const authRedirectInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const dialogService = inject(DialogService);
  const spinnerService = inject(SpinnerService);
  const authService = inject(AuthService);
  const excludedUrlFromHandle401Error = [
    '/signIn',
    '/signInSignature',
    '/auth/user',
  ];

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isExcludedUrl = excludedUrlFromHandle401Error.some((url) =>
        req.url.endsWith(url),
      );
      if (error.status === 401 && !isExcludedUrl) {
        const wasLoggedIn = authService.hasSession();

        dialogService.dialogComponentRefMap.forEach((componentRef) => {
          componentRef.instance.close();
        });

        if (!wasLoggedIn) {
          router.navigate([APP_PATHS.auth.root, APP_PATHS.auth.loginMethod]);
          return EMPTY;
        }

        router
          .navigate([APP_PATHS.auth.root, APP_PATHS.auth.loginMethod])
          .then(() => {
            messageService.add({
              severity: ToastSeverity.ERROR,
              summary: 'Sesja wygasła. Zaloguj się ponownie',
            });
          });
        return EMPTY;
      } else if (error.status === 403) {
        dialogService.dialogComponentRefMap.forEach((componentRef) => {
          componentRef.instance.close();
        });
        messageService.add({
          severity: ToastSeverity.ERROR,
          summary: 'Brak dostępu do zawartości.',
        });
        if (router.url !== '/') {
          router.navigate(['/']);
        }
        return EMPTY;
      } else if (error.status === 0 && !isExcludedUrl) {
        router
          .navigate([APP_PATHS.auth.root, APP_PATHS.auth.loginMethod])
          .then(() => {
            spinnerService.reset();
            messageService.add({
              severity: ToastSeverity.ERROR,
              summary: 'Wystąpił błąd serwera. Spróbuj ponownie za kilka minut',
            });
          });
        return EMPTY;
      }
      return throwError(() => error);
    }),
  );
};
